export const KeyCode = {
  Enter: 13,
  Esc: 27
};

export enum KeyboardCode {
  Enter = 'Enter',
  Escape = "Escape"
}
